import { $GQL } from '@GQL/index';

export async function getAdAuctionPlacementsAsOptions() {
	const query = `
        query GetAdAuctionPlacements {
            adAuctionPlacements
        }
    `;

	const results = await $GQL.request(query);
	return results.adAuctionPlacements.map((placement: string) => ({
		label: placement,
		value: placement,
	}));
}
